/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Contactdetails1Inputs */

const en_entity_contactdetails1 = /** @type {(inputs: Entity_Contactdetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Details`)
};

const de_entity_contactdetails1 = /** @type {(inputs: Entity_Contactdetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktdetails`)
};

/**
* | output |
* | --- |
* | "Contact Details" |
*
* @param {Entity_Contactdetails1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_contactdetails1 = /** @type {((inputs?: Entity_Contactdetails1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Contactdetails1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_contactdetails1(inputs)
	return de_entity_contactdetails1(inputs)
});
export { entity_contactdetails1 as "entity_contactDetails" }